import React from 'react'
import PropTypes from 'prop-types'

import BaseSearchIcon from '../../icons/svg/search'

const SearchIcon = props =>
  <BaseSearchIcon scale={props.scale || 0.6} fill={props.fill} />

SearchIcon.propTypes = {
  scale: PropTypes.number,
  fill: PropTypes.string,
}

export default SearchIcon